import styled from "@emotion/styled";
import { useEffect, useRef } from "react";

const Root = styled.div`
  grid-row: 1;
  grid-column: 1;
  width: 100%;
  font-size: 0.4rem;
  min-height: 57vh;
  max-height: 100%;
  overflow-x: hidden; // Prevent horizontal scrolling
`;

/*
Using https://publish.twitter.com/ to generate a Twitter feed for embed 
does not work out of the box with React, because the asynchronous Twitter script 
used to render the feed does not properly communicate with the required DOM element.

This solution instantiates the required <script> element for rendering the Twitter feed,
and then appends this <script> element to the Twitter feed container DOM element, 
using useEffect() -- to wait until after component rendering has completed. 

It also waits for component rendering to complete before determining what height 
should be set for the resulting feed.

// See: https://dev.to/heymarkkop/embed-twitter-widget-on-reactjs-1768

*/

const TwitterFeed = () => {
  const feedElement = useRef<HTMLDivElement | null>(null);

  useEffect(() => {
    if (!feedElement.current) {
      return;
    }

    const script = document.createElement("script");
    script.src = "https://platform.twitter.com/widgets.js";
    script.async = true;
    script.onload = () => {
      (window as { twttr?: { widgets?: { load: (el?: Element | null) => void } } })
        .twttr?.widgets?.load(feedElement.current);
    };
    feedElement.current.appendChild(script);
  }, []);

  return (
    <Root ref={feedElement}>
      <blockquote className="twitter-tweet">
        <p lang="en" dir="ltr">
          📢 We deployed our first “learning resource” in the Atlas of Economic
          Complexity: the Product Space tutorial. <br />
          <br />
          This feature - devoid of scientific jargon - is designed to give new
          users a quick, accessible introduction to the Product Space before
          diving in. <br />
          <br />
          Our goal is to…{" "}
          <a href="https://t.co/41OhhXodwR">pic.twitter.com/41OhhXodwR</a>
        </p>
        &mdash; Harvard&#39;s Growth Lab (@HarvardGrwthLab){" "}
        <a href="https://twitter.com/HarvardGrwthLab/status/1892582360098500683?ref_src=twsrc%5Etfw">
          February 20, 2025
        </a>
      </blockquote>
    </Root>
  );
};

export default TwitterFeed;
